import * as angular from 'angular';

class ComfortBidConfirmFormComponentCtrl implements ng.IController {}

angular.module('app').component('pkpComfortBidConfirmForm', {
    controller: ComfortBidConfirmFormComponentCtrl,
    template: require('app/comfort-bid/comfort-bid-confirm-form.component.html'),
    bindings: {
        networkPoint: '=',
        tsoConfig: '='
    }
});
